import CommandViewModel, {
  CommandListEntryType,
  CommandListEntryViewModel,
  CommandName,
} from '../../../../services/commands/CommandViewModel';

export const getCommand = (
  commandName: CommandName | undefined,
  commandList: CommandViewModel[] | undefined
): CommandListEntryViewModel | undefined => {
  if (!commandName || !commandList) {
    return;
  }
  for (const commandEntry of commandList) {
    if (
      commandEntry.type === CommandListEntryType.COMMAND &&
      commandEntry.name === commandName
    ) {
      return commandEntry;
    } else if (
      commandEntry.type === CommandListEntryType.GROUP &&
      commandEntry.children.length > 0
    ) {
      const result = getCommand(commandName, commandEntry.children);
      if (result !== undefined) {
        return result;
      }
    }
  }
};
